import { render, staticRenderFns } from "./detailBanner.vue?vue&type=template&id=2914f0ce&scoped=true"
import script from "./detailBanner.vue?vue&type=script&lang=js"
export * from "./detailBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2914f0ce",
  null
  
)

export default component.exports